import { Box, Button } from '@mui/material';
import { DialogType } from '../../context/types/DialogType';

const baseButtonSx = {
  textTransform: 'none',
  borderRadius: 2,
  minHeight: 34,
  px: 1.5,
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1.1,
} as const;

const CreateTypeTabs = ({
  value,
  onChange,
  labels,
}: {
  value: DialogType;
  onChange: (v: DialogType) => void;
  labels: { event: string; task: string };
  disabledTask?: boolean;
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Button
        size="small"
        onClick={() => onChange('event')}
        variant={value === 'event' ? 'contained' : 'text'}
        disableElevation
        color="primary"
        sx={{ ...baseButtonSx }}
      >
        {labels.event}
      </Button>

      <Button
        size="small"
        onClick={() => onChange('task')}
        variant={value === 'task' ? 'contained' : 'text'}
        disableElevation
        sx={{ ...baseButtonSx }}
        color="primary"
      >
        {labels.task}
      </Button>
    </Box>
  );
};

export default CreateTypeTabs;
